export default {
  assign_day: 'Content assigned',
  due_day: 'Due date',
  assignment_notifications: 'Assignment notifications',
  due_date_notifications: 'Due date reminder',
  past_due_notifications: 'Past due notification',
  custom_notifications: 'Notification assigned',
  // featuredContent: 'Featured content',
};
